import { render } from "./AsidePrimary.vue?vue&type=template&id=0f7bcad5&ts=true"
import script from "./AsidePrimary.vue?vue&type=script&lang=ts"
export * from "./AsidePrimary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__